import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=21f6ef78"
import script from "./appSidebar.ts?vue&type=script&lang=ts&external"
export * from "./appSidebar.ts?vue&type=script&lang=ts&external"
import style0 from "./app-sidebar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports